import React from 'react';

import KeyDevelopmentDetails from './KeyDevelopmentDetails';

export default React.memo(KeyDevelopmentDetails);
